import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: var(--surface);
  border-radius: 12px;
  max-width: 700px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid var(--accent-light);
  /* Fix za Chrome glitch pri brzom skrolu (providan/pomeren sadržaj):
     sopstveni compositing sloj + bez prenošenja skrola na pozadinu */
  transform: translateZ(0);
  overscroll-behavior: contain;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 1px solid var(--accent-light);
  background: var(--surface-light);
  border-radius: 12px 12px 0 0;
`;

export const ModalTitle = styled.h3`
  color: var(--text);
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: var(--accent);
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--surface-hover);
    color: var(--text);
  }
`;

export const ModalGrid = styled.div`
  padding: 32px;
  display: grid;
  gap: 24px;
`;

export const UserDetailsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--surface-light);
  border-radius: 12px;
  border: 1px solid var(--accent-light);
`;

export const UserDetailsAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1.25rem;
  text-transform: uppercase;
  flex-shrink: 0;
`;

export const UserDetailsInfo = styled.div`
  flex: 1;
`;

export const UserDetailsName = styled.h2`
  color: var(--text);
  margin: 0 0 4px 0;
  font-size: 1.5rem;
  font-weight: 600;
`;

export const UserDetailsId = styled.p`
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.875rem;
  font-family: "Courier New", monospace;
`;

export const ContactInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoField = styled.div`
  padding: 16px;
  background: var(--surface-light);
  border-radius: 8px;
  border: 1px solid var(--accent-light);
`;

export const InfoLabel = styled.label`
  display: block;
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const InfoValue = styled.div`
  color: var(--text);
  font-size: 1rem;
  font-weight: 500;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div`
  padding: 20px;
  background: var(--surface-light);
  border-radius: 12px;
  border: 1px solid var(--accent-light);
  text-align: center;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
`;

export const StatValue = styled.div`
  font-size: ${(props) => (props.$small ? "1rem" : "2rem")};
  font-weight: 700;
  color: var(--accent);
  display: flex;
  flex-direction: row;
  line-height: 2rem;
  margin-bottom: ${(props) => (props.$small ? "0" : "4px")};
`;

export const StatLabel = styled.div`
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
`;

export const RegistrationSection = styled.div`
  padding: 20px;
  background: var(--surface-light);
  border-radius: 12px;
  border: 1px solid var(--accent-light);
  display: flex;
  flex-direction: column;

  gap: 16px;
`;

export const ModalActions = styled.div`
  padding: 20px 32px;
  border-top: 1px solid var(--accent-light);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: var(--surface-light);
  border-radius: 0 0 12px 12px;
`;

export const Button = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;

  background: ${(props) =>
    props.$secondary ? "var(--surface)" : "var(--accent)"};
  color: ${(props) => (props.$secondary ? "var(--text)" : "white")};
  border: ${(props) =>
    props.$secondary ? "1px solid var(--accent-light)" : "none"};

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.$secondary ? "var(--surface-hover)" : "var(--accent-dark)"};
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;
